jQuery(document).ready(function ($) {
  function gatherAccordions() {
    var r = $.Deferred();
    $(':not(.accordion) + .accordion, * > .accordion:first-of-type').each(function () {
      $(this).nextUntil(':not(.accordion)').addBack().wrapAll('<div class="accordions active" />');
    });
    return r;
  }
  function accordionTitles() {
    var r = $.Deferred();
    var titleCount = 0;
    $('.accordions .accordion:not(".alternate") .accordion-title').each(function () {
      titleCount++;
      var $this = $(this);
      var id = 'accordion-' + titleCount;
      var titleID = 'accordion-title-' + titleCount;
      var svgMarkupClosed = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><!--!Font Awesome Free 6.5.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.--><path d="M233.4 406.6c12.5 12.5 32.8 12.5 45.3 0l192-192c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L256 338.7 86.6 169.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l192 192z"/></svg>';
      var svgMarkupOpen = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><!--!Font Awesome Free 6.5.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.--><path d="M233.4 105.4c12.5-12.5 32.8-12.5 45.3 0l192 192c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L256 173.3 86.6 342.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l192-192z"/></svg>';
      $this.attr('id', titleID);
      if ($this.hasClass('open')) {
        $this.addClass('is-active');
        if ($this.is('div')) {
          $('h2', $this).wrapInner('<button onclick="return false;" aria-expanded="true" aria-controls="' + id + '">');
        } else {
          $this.wrapInner('<button onclick="return false;" aria-expanded="true" aria-controls="' + id + '">');
        }
      } else {
        if ($this.is('div')) {
          $('h2', $this).wrapInner('<button onclick="return false;" aria-expanded="false" aria-controls="' + id + '">');
          $('button', $this).append(svgMarkupClosed);
        } else {
          $this.wrapInner('<button onclick="return false;" aria-expanded="false" aria-controls="' + id + '">');
          $('button', $this).append(svgMarkupClosed);
        }
      }
    });
    return r;
  }

  function accordionTitlesAlternate() {
    var r = $.Deferred();
    var titleCount = 0;
    $('.accordions .accordion.alternate .accordion-title').each(function () {
      titleCount++;
      var $this = $(this);
      var id = 'accordion-alt-' + titleCount;
      var titleID = 'accordion-title-' + titleCount;
      $this.attr('id', titleID);
      if ($this.hasClass('open')) {
        $this.addClass('is-active');
        if ($this.is('div')) {
          $('h2', $this).append('<button onclick="return false;" aria-expanded="true" aria-controls="' + id + '">View More <span class="fa fa-caret-down"></span></button>');
        } else {
          $this.append('<button onclick="return false;" aria-expanded="true" aria-controls="' + id + '">View More <span class="fa fa-caret-down"></span></button>');
        }
      } else {
        if ($this.is('div')) {
          $('h2', $this).append('<button onclick="return false;" aria-expanded="false" aria-controls="' + id + '">View More <span class="fa fa-caret-down"></span></button>');
        } else {
          $this.append('<button onclick="return false;" aria-expanded="false" aria-controls="' + id + '">View More <span class="fa fa-caret-down"></span></button>');
        }
      }

      $('.accordions .accordion.alternate .accordion-title button').each(function () {
        $(this).appendTo($(this).parent().parent());
      });

    });
    return r;
  }

  function accordionContent() {
    var r = $.Deferred();
    var contentCount = 0;
    $('.accordions .accordion .accordion-content').each(function () {
      contentCount++;
      var $this = $(this);
      var id = 'accordion-' + contentCount;
      if ($this.prev('.accordion-title').hasClass('is-active')) {
        $this.attr('id', id).attr('aria-hidden', 'false');
      } else {
        $this.attr('id', id).attr('aria-hidden', 'true');
      }
    });
    return r;
  }

  function accordionContentAlternate() {
    var r = $.Deferred();
    var contentCount = 0;
    $('.accordions .accordion.alternate .accordion-content').each(function () {
      contentCount++;
      var $this = $(this);
      var id = 'accordion-alt-' + contentCount;
      if ($this.prev('.accordion-title').hasClass('is-active')) {
        $this.attr('id', id).attr('aria-hidden', 'false');
      } else {
        $this.attr('id', id).attr('aria-hidden', 'true');
      }
    });
    return r;
  }

  function accordionButtons() {
    $('.accordions .accordion button').on('click', function (e) {
      e.preventDefault();
      var id = $(this).attr('aria-controls');
      var state = $(this).attr('aria-expanded');
      var panel = $('.accordion-content#' + id);
      if ($(this).parent().hasClass('is-active')) {
        $(this).parent().removeClass('is-active').addClass('is-inactive');
        $(this).attr('aria-expanded', 'false');
        panel.attr('aria-hidden', 'true');
      } else {
        $(this).parent().removeClass('is-inactive').addClass('is-active');
        $(this).attr('aria-expanded', 'true');
        panel.attr('aria-hidden', 'false');
      }
    });

    $('.accordions .accordion.alternate button').on('click', function (e) {
      e.preventDefault();
      if ($(this).parent().hasClass('is-active')) {
        $(this).html("View Less <span class='fa fa-caret-up'></span>");
      } else {
        $(this).html("View More <span class='fa fa-caret-down'></span>");
      }
    });
  }

  gatherAccordions().done(accordionTitles().done(accordionTitlesAlternate().done(accordionContent().done(accordionContentAlternate().done(accordionButtons())))));

  if (window.location.hash) {
    var hash = window.location.hash;
    var urlAccordion = $('.accordion-title' + hash);
    if (urlAccordion.length) {
      console.log('has hash');
      urlAccordion.addClass('is-active');
      urlAccordion.find('> button').attr('aria-expanded', 'true');
      urlAccordion.next('.accordion-content').attr('aria-hidden', 'false');
    }
  }
});